import React, { useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { func } from 'prop-types';
import { Alert, Row, Col } from 'reactstrap';
import Layout from '../../../../components/Layout/Layout';
import Card from '../../../../components/Card/Card';
import PaymentsData from '../../../../components/Finances/PaymentsData';
import PaymentOrders from '../../../../components/Finances/PaymentOrders/PaymentOrders';
import PaymentHoldDetails from '../../../../components/Finances/PaymentHoldDetails';
import OffChecksContestWidget from '../../../../widgets/OffChecksContestWidget/OffChecksContestWidget';
import WithAlert from '../../../../hoc/WithAlert';
import Hold2BalanceOrder from '../../../../components/Finances/Hold2BalanceOrder';
import { updateLocation, currencyToSign } from '../../../../utils/utils';
import { parse } from 'query-string';
import PaymentsConvertingAlert from '../../../../components/Finances/PaymentsConvertingAlert';
import PaymentsBankCardsChangesAlert from '../../../../components/Finances/PaymentsBankCardsChangesAlert';

const propTypes = {
  showAlert: func,
  intl: intlShape.isRequired,
};

const defaultProps = {
  showAlert() { },
};

const tabKeys = {
  payment: 1,
  info: 2,
  hold: 3,
};

const navs = (intl, isSlave) => {
  const navBtns = [
    <FormattedMessage id="payments.list.title" defaultMessage="Financial info" />,
    <FormattedMessage id="payments.hold.title" defaultMessage="Hold detail" />,
  ];
  if (!isSlave) {
    navBtns.unshift(
      <FormattedMessage id="payments.orders.title" defaultMessage="Payments order" />
    );
  }
  return navBtns;
};

const btns = [Hold2BalanceOrder];

const FinancesPage = ({ showAlert, intl, history, isMember, className, isSlave, balance, hasRUBankCards }) => {
  const activeTab = () => {
    switch (parse(history.location.search).tab) {
      case 'payment':
        return 1
      case 'info':
        return 2
      case 'hold':
        return 3
      default:
        return 1;
    }
  }
  const [loading, setLoadingState] = useState(false);

  const getBtnProps = () => ({
    hold2BalanceOrderDisable: isSlave && !isMember
  });

  const handleTabChange = tab => {
    Object.keys(tabKeys).forEach((key, index) => {
      if (index + 1 === tab) {
        updateLocation({ tab: key });
      }
    });
  };

  const renderTabs = () => {
    const tabs = [
      <PaymentsData key='PaymentsData' history={history} />,
      <PaymentHoldDetails
        history={history}
        key='PaymentHoldDetails'
        setLoadingState={setLoadingState}
        loading={loading}
        intl={intl}
      />
    ];
    if (!isSlave) {
      tabs.unshift(<PaymentOrders tabProps={{ history }} showAlert={showAlert} key='PaymentOrders' />);
    }
    return tabs;
  };

  return (
    <Fragment>
      {!isMember ?
        <Layout formattedTitle="pages.payments.title">
          <Layout.Col>
            <Alert className='balance-info-banner'>
              <Row>
                <Col xs='12'>{balance && <FormattedMessage values={{ hold: balance[0].hold, balance: balance[0].balance, currency: currencyToSign(balance[0].currency) }} id='payments.balance.banner' defaultMessage="On your balance: {balance} {currency}, on hold: {hold} {currency}" />}</Col>
              </Row>
            </Alert>
          </Layout.Col>
          <Layout.Col>
            <OffChecksContestWidget />
          </Layout.Col>
          <Layout.Col>
            <PaymentsConvertingAlert theme={4} />
          </Layout.Col>
          {hasRUBankCards ? (
            <Layout.Col>
              <PaymentsBankCardsChangesAlert />
            </Layout.Col>
          ) : null}
          <Layout.Col>
            <Card.Tabs
              title={<Hold2BalanceOrder showAlert={showAlert} />}
              noPadding={true}
              navItems={navs(intl, isSlave)}
              tabProps={{ history }}
              btnItems={btns}
              panes={renderTabs()}
              btnProps={getBtnProps()}
              showAlert={showAlert}
              loading={loading}
              activeTab={activeTab()}
              onTabChange={handleTabChange}
            />
          </Layout.Col>
        </Layout>
        :
        <Card.NavTabs
          navItems={navs(intl)}
          tabProps={{ history }}
          btnItems={btns}
          btnProps={getBtnProps()}
          showAlert={showAlert}
          loading={loading}
          activeTab={activeTab}
          className={className}
        >
          <PaymentsData
            isMember={isMember}
          />
          <PaymentHoldDetails
            setLoadingState={setLoadingState}
            loading={loading}
            isMember={isMember}
          />
          {!isSlave &&
            <PaymentOrders
              showAlert={showAlert}
              isMember={isMember}
            />
          }
        </Card.NavTabs>
      }
    </Fragment>
  );
};


FinancesPage.propTypes = propTypes;
FinancesPage.defaultProps = defaultProps;

const mapStateToProps = ({ webmaster }) => ({
  balance: webmaster.balance,
  isSlave: webmaster.isSlave,
  hasRUBankCards: webmaster.profile.has_ru_bank_cards,
});

export default connect(mapStateToProps)(WithAlert(injectIntl(FinancesPage)));
